// extracted by mini-css-extract-plugin
export var actionButton = "_dt-0";
export var attachmentLine = "_dt-1";
export var fileInput = "_dt-2";
export var fileUploadWrapper = "_dt-4";
export var footer = "_dt-3";
export var modalContent = "_dt-5";
export var paperclip = "_dt-6";
export var quillEditor = "_dt-7";